export default [
  {
    path: '/admin/import-tax-models',
    name: 'import-tax-models',
    meta: { requiresAuth: true },
    component: () => import('@/pages/setting/import-tax-model/index.vue')
  }
]
